import React, { useEffect } from 'react';
import ContentPage          from '../ContentPage/ContentPage';
import { FourSquare }       from 'react-loading-indicators';

const MAP_URL = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2685.2105819525977!2d6.896646876588532!3d50.98167324897299!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47bf3160cc35cf93%3A0xf5441a15d9d0fb94!2sMR%20-%20luxury%20watches%2C%20Michael%20Ruckes!5e1!3m2!1sde!2sde!4v1780224684407!5m2!1sde!2sde';

const ShowroomPage: React.FC = () => {

  const [map, setMap] = React.useState<string|null>(null);
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    const timeout = window.setTimeout(() => {
      setMap(MAP_URL);
    }, 500);
    const lTimeout = window.setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => {
      window.clearTimeout(timeout);
      window.clearTimeout(lTimeout);
    };

  }, []);

  return (
    <ContentPage slug="showroom" title="Showroom">
      <div style={{ width: '100%', height: 600, marginBottom: 24, position: 'relative' }}>
        <iframe
          title="MR Luxury Watches Google Maps"
          src={ map || 'https://www.google.de' }
          width="600"
          height="600"
          style={{ border: 0, width: '100%' }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
        { loading && (
          <div style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#fff' }} >
            <FourSquare color="#657455" size="medium" text="" textColor="" />
          </div>) }
      </div>

    </ContentPage>
  )
};

export default ShowroomPage;
